/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateUserStatus } from 'state/actions/user_status';
import { signInWithValidation } from 'state/actions/auth_status';
import { setAuthData, storeSessionData } from 'state/actions/session_status';
import { discardChanges } from '@insticator/insticator-ui';
import { setFormFieldValue, setFieldValidation } from '@insticator/insticator-ui';
import { getAllSites } from 'state/actions/accountState/account_data';
import { getCommentingData } from 'state/actions/commentingState/commentingStatus';
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui'; // iui-utils
// component
import SignIn from 'pages/auth/signin/signin';



/* ========== ~~~~~~~~~~ AUTH SIGN IN ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ authStatus }) => ({
    fields: authStatus.signin.fields,
    savingData: authStatus.signin.savingData
});

// map actions
const mapDispatchToProps = dispatch => ({
    updatePageDetails: (location) => dispatch(updatePageDetails(location)),
    displayMessage: message => dispatch(displayMessage(message)),
    updateUserStatus: value => dispatch(updateUserStatus(value)),
    signIn: (fields, formData, successAction, failAction) => dispatch(signInWithValidation(fields, formData, successAction, failAction)),
    setAuthData: response => dispatch(setAuthData(response)),
    discardChanges: formName => dispatch(discardChanges(formName)),
    displayErrorMessage: errorMessage => dispatch(displayErrorMessage(errorMessage)),
    displaySuccessMessage: successMessage => dispatch(displaySuccessMessage(successMessage)),
    setFormFieldValue: (formName, fieldName, value) => dispatch(setFormFieldValue(formName, fieldName, value)),
    setFieldValidation: (formName, fieldName, validationStatus) => dispatch(setFieldValidation(formName, fieldName, validationStatus)),
    getAllSites: accountUUID => dispatch(getAllSites(accountUUID)),
    getCommentingData: accountUUID => dispatch(getCommentingData(accountUUID)),
    storeSessionData: sessionData => dispatch(storeSessionData(sessionData)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SignIn);
